<template>
  <div class="bg-white echart-container">
    <div id="sellAmount" style="width: 960px;height: 204px;"></div>
  </div> 
</template>

<script>
import echarts from '@/utils/echart'
export default {
  props: ['range'],
  data () {
    return {
      charts: null,
      dataRange: ['周天', '周一', '周二', '周三', '周四', '周五', '周六'],
      data: [0, 0, 0, 0, 0, 0, 0]
    }
  },
  watch: {
    range: function (newRange) {
      this.updateRange(newRange);
      this.charts.setOption(this.getOptions(), true);
    }
  },
  mounted(){
    this.updateRange(this.range);
    this.$nextTick(function() {
      this.drawChart('sellAmount')
    })
  },
  methods: {
    drawChart(id) {
      this.charts = echarts.init(document.getElementById(id))
      this.charts.setOption(this.getOptions());
    },
    getOptions() {
      return {
        xAxis: {
          type: 'category',
          data: this.dataRange,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.5)'
            }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          boundaryGap: false,
          splitLine: {
            lineStyle: {
              color: ['#f5f5f5']
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.5)'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          position: function (pos, params, el, elRect, size) {
            var obj = {top: 10};
            obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
        },
        series: [{
          lineStyle: {
            color: 'rgba(255, 125, 98, 0.8)'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                {offset: 0, color: 'rgba(255, 125, 98, 0.5)'},
                {offset: 0.8, color: 'rgba(255, 125, 98, 0)'}
              ]
            )
          },
          data: this.data,
          type: 'line',
          smooth: true,
        }]
      };
    },
    updateRange(newRange) {
      switch(newRange) {
        case '1':
          this.buildData(7);
          break;
        case '2':
          this.buildData(30);
          break;
        case '3':
          this.buildData(180);
          break;
        case '4':
          this.buildData(365);
          break;
      }
    },
    buildData(range) {
      var _dataRange = [];
      var _data = [];
      var now = new Date();
      var nowTime = now.getTime();
      for (var ii = 0; ii < range; ii ++) {
        _dataRange.push(this.getDateStringWithStep(nowTime, ii));
        _data.push(Math.floor(Math.random()*1000) + 500);
      }
      this.dataRange = _dataRange.reverse();
      this.data = _data.reverse();
    },
    getDateStringWithStep(nowTime, i) {
      var _thisTime = nowTime - (i * 86400 * 1000);
      var _thisDate = new Date(_thisTime);
      return _thisDate.getFullYear() + '.' + (_thisDate.getMonth() + 1) + '.' + _thisDate.getDate();
    }
  }
}
</script>

<style lang="scss" scoped>
  .echart-container {
    height: 204px;
    box-shadow: $box-shadow-base;
    border-radius: $border-radius-base;
  }
</style>
